import { styled, Typography } from "@mui/material";
import { useRef } from "react";
import { useIsVisible } from "../hooks/useIsVisible";

const BoldHeadingStyle = styled(Typography)`
  // background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  // -webkit-background-clip: text;
  // -webkit-text-fill-color: transparent;
  // background-clip: text;
  // text-fill-color: transparent;
  line-height: 1.12;
  min-width: fit-content;

  // ${({ theme }) => theme.breakpoints.only("xs")} {
  //   font-size: 3rem;
  // }
`;

const BoldHeading = ({ children, className, ...props }) => {
  const ref = useRef();
  const isVisible = useIsVisible(ref);

  return (
    <BoldHeadingStyle
      ref={ref}
      variant="h1"
      className={`hero-text ${isVisible ? "animate" : ""} ${className}`}
      {...props}
    >
      {children}
    </BoldHeadingStyle>
  );
};

export default BoldHeading;
